import { useEffect, useState } from "react";
import { Button, Checkbox, Modal } from "src/components";
import InvoiceMapping from "./invoice-mapping";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import successCircle from "src/assets/successCircle.svg";
import { useNavigate } from "react-router-dom";
import editPen from "src/assets/edit-pen.svg";
import { useDispatch } from "react-redux";
import { invoiceActions } from "src/context/invoice-slice";

const InvoiceProductMapping = () => {
  const [openProductMapping, setOpenProductMapping] = useState(false);
  const [mappingData, setMappingData] = useState<any>([]);
  const { invoicesTextractData, invoiceDetails } = useSelector((state: RootState) => state.invoice);
  const [isOriginalSet, setIsOriginalSet] = useState(false);
  const { invoiceMappingOriginalDescriptions } = useSelector((state: RootState) => state.invoice);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  function generateShortUniqueKey(length = 7) {
    const base36Time = Date.now().toString(36).slice(-3); // last 3 chars from timestamp
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let randomPart = '';

    for (let i = 0; i < length - base36Time.length; i++) {
      randomPart += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return (base36Time + randomPart).slice(0, length); // ensure total length
  }

  const handleConfirmInvoice = () => {
    if (invoicesTextractData?.length > 0) {
      const updatedItems = invoicesTextractData.map((item: any) => {
        const isUnknownAndMissingCode =
          item?.is_item_unknown === true &&
          (!item?.item_code || item?.item_code?.trim() === "");

        if (isUnknownAndMissingCode) {
          return {
            invoice_product_id: item?.invoice_product_id,
            unique_key: item?.invoice_product_id,
            invoice_id: invoiceDetails?.invoice?.invoice_id,
            item_description: item?.item_description,
            item_code: generateShortUniqueKey(),
            quantity: item?.quantity,
            gst: item?.p_gst_perc,
            cash_dis_perc: item?.p_cash_discount_perc ?? 0,
            ptr: Number(item?.ptr),
            discount_type: item?.discount_type,
            free_qty: item?.free_qty,
            batch_no: item?.batch_no,
            inv_rate: String(item?.inv_rate),
            inv_mrp: String(item?.inv_mrp),
            discount_amt: String(item?.discount_amt),
            counter_code: invoiceDetails?.counter_code,
            is_item_unknown: item?.is_item_unknown,
            gross_amt: String((Number(item?.ptr) * Number(item?.quantity))?.toFixed(2)),
          };
        }

        // return the original item if it doesn't match the condition
        return item;
      });

      dispatch(invoiceActions.setInvoicesTextractData(updatedItems));

      navigate(`/transactions/invoice/${invoiceDetails?.stockist_invoice_attachment_id}/0`);
    }
  };



  useEffect(() => {
    if (invoicesTextractData.length > 0 && !isOriginalSet && invoiceMappingOriginalDescriptions?.length === 0) {
      const invoiceMappingOriginalDescription = invoicesTextractData.reduce(
        (acc: Record<string, string>, row: any) => {
          if (row?.invoice_product_id && row?.item_description) {
            acc[row.invoice_product_id] = row.item_description;
          }
          return acc;
        },
        {}
      );
      dispatch(invoiceActions.setInvoiceMappingOriginalDescriptions(invoiceMappingOriginalDescription));
      setIsOriginalSet(true);
    }
  }, [invoicesTextractData, isOriginalSet, invoiceMappingOriginalDescriptions]);

  return (
    <div className="min-h-[400px]">
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "left",
          border: "1px solid #ccc",
          // height:"300px"
        }}
        className="mt-10"
      >
        <thead>
          <tr className="text-sm bg-[#F1F1F1]">
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}></th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Invoice Product Description</th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Master Product Description</th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Map</th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Edit</th>
          </tr>
        </thead>
        <tbody>
          {[...new Map(invoicesTextractData.map((item: any) => [(item.item_description || "").replace(/[^\w\s]/gi, ""), item])).values(),].map(
            (row: any, index: any) => (
              (
                <tr key={index} className="w-full">
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-[20%] text-gray-500">
                    <Checkbox />
                  </td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-[20%] text-sm">
                    {invoiceMappingOriginalDescriptions[row?.invoice_product_id] || row?.item_description}
                  </td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-[32%] text-sm">
                    {row?.is_item_unknown === false ? row?.item_description : "-"}
                  </td>
                  {row?.is_item_unknown ? (
                    <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-[6%]">
                      <div
                        onClick={() => {
                          setMappingData(row);
                          if (mappingData) {
                            setOpenProductMapping(true);
                          }
                        }}
                      >
                        <button className="px-2 py-1 bg-gray-200 rounded-md">↔</button>
                      </div>
                    </td>
                  ) : (
                    <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-[6%]">
                      <img src={successCircle} alt="cross" className="w-5 h-5 font-bold cursor-pointer" />
                    </td>
                  )}
                  <td style={{ padding: "0px", borderBottom: "1px solid #ccc" }} className="w-[6%]">
                    {row?.is_item_unknown === false && <Button onClick={() => {
                      setMappingData(row);
                      if (mappingData) {
                        setOpenProductMapping(true);
                      }
                    }}>
                      <img src={editPen} alt="delete" className="w-4 h-4" />
                    </Button>}
                  </td>
                </tr>
              )
            )
          )}
        </tbody>
      </table>
      <div className="flex justify-between mt-14 gap-x-2">
        <>
          <Button
            onClick={() => {
              navigate(`/transactions/invoice/${invoiceDetails?.stockist_invoice_attachment_id}/${0}`);
            }}
            className="font-normal bg-gray-200 border border-gray-300"
          >
            Go Manual
          </Button>
        </>
        <div className="flex gap-x-2">
          <Button className="font-normal bg-gray-200 border border-gray-300">Escalate to Master</Button>
          <Button
            onClick={handleConfirmInvoice}
            className="font-normal text-white bg-primary"
          >
            Confirm Invoice
          </Button>
        </div>
      </div>
      <Modal isOpen={openProductMapping} isHeader={false} onCloseModal={() => setOpenProductMapping(false)} title="Escalate Invoice">
        <InvoiceMapping onCloseModal={() => setOpenProductMapping(false)} mappingData={mappingData} />
      </Modal>
    </div>
  );
};

export default InvoiceProductMapping;
